var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScience(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 122.784,
    height: 122.673,
    viewBox: "0 0 122.784 122.673",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-science-1159008",
    transform: "translate(-10.624)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_436",
    "data-name": "Caminho 436",
    d: "M156.33,178.016a1.562,1.562,0,0,0,.495.082H184.3a1.557,1.557,0,0,0,.495-.082,43.853,43.853,0,0,0-.985-83.285V77.289a5.411,5.411,0,0,0-1.081-10.712h-.487V59.513a3.9,3.9,0,0,0-3.9-3.9H162.786a3.9,3.9,0,0,0-3.9,3.9v7.063H158.4a5.412,5.412,0,0,0-1.079,10.714v17.44a43.854,43.854,0,0,0-.988,83.285Zm5.613-118.5a.84.84,0,0,1,.839-.839h15.562a.84.84,0,0,1,.839.839v7.063h-17.24ZM159.27,97.335a1.527,1.527,0,0,0,1.107-1.469V75.871a1.527,1.527,0,0,0-1.529-1.529H158.4a2.354,2.354,0,1,1,0-4.708H182.73a2.354,2.354,0,0,1,0,4.708h-.448a1.527,1.527,0,0,0-1.529,1.529v20a1.529,1.529,0,0,0,1.107,1.469A40.731,40.731,0,0,1,204,113.287H137.131a40.73,40.73,0,0,1,22.138-15.952ZM135.2,116.342h70.736a40.648,40.648,0,0,1-21.886,58.7H157.082a40.648,40.648,0,0,1-21.886-58.7Z",
    transform: "translate(-116.09 -55.618)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_437",
    "data-name": "Caminho 437",
    d: "M477.548,56h-24.11a5.578,5.578,0,0,0-5.6,4.858,5.41,5.41,0,0,0,4.3,5.853v98.613a13.246,13.246,0,0,0,26.492,0V66.669a5.515,5.515,0,0,0,4.3-4.707A5.413,5.413,0,0,0,477.548,56ZM465.381,175.512a10.2,10.2,0,0,1-10.188-10.188V79.116h20.378v86.208a10.2,10.2,0,0,1-10.19,10.189ZM477.326,63.764H477.1a1.527,1.527,0,0,0-1.529,1.529V76.06H455.194V65.292a1.527,1.527,0,0,0-1.529-1.529h-.449a2.354,2.354,0,0,1-2.342-2.6,2.5,2.5,0,0,1,2.564-2.106h24.109a2.359,2.359,0,0,1,1.747.776,2.334,2.334,0,0,1,.6,1.826,2.5,2.5,0,0,1-2.564,2.106Z",
    transform: "translate(-349.549 -55.895)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScience);
export default __webpack_public_path__ + "static/media/science.3cc7e075fcd2f5fc68eec637f4db5343.svg";
export { ForwardRef as ReactComponent };